import { render, staticRenderFns } from "./FundCalculator.vue?vue&type=template&id=6c489988&scoped=true&"
import script from "./FundCalculator.vue?vue&type=script&lang=js&"
export * from "./FundCalculator.vue?vue&type=script&lang=js&"
import style0 from "./FundCalculator.vue?vue&type=style&index=0&id=6c489988&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c489988",
  null
  
)

export default component.exports